import * as api from "Api";
import * as actions from "Actions";

export const fetchPeriodFinancialSheet = () => {
  return (dispatch, getState) => {
    const { currentOrganization, partner, partnerZone } = getState().auth;
    const {
      year,
      collaborator,
      client,
      clientGroup,
      squads,
      cluster,
      businessUnit,
      sortBy,
      searchWord
    } = getState().financialSheet.periodFilter;
    const {
      tab,
      filter: {
        clientTypes,
        clientCRMGroup,
        clientCRMTypes,
        role,
        isEntity,
        start,
        limit
      }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus }
    } = getState().clients.filter;

    dispatch(
      actions.fetchPeriodFinancialSheetTree(
        api
          .getPeriodFinancialSheetTree(
            currentOrganization.id,
            partner,
            partnerZone,
            client.selected,
            clientGroup.selected,
            collaborator.selected,
            year.selected,
            squads.selected,
            cluster.selected,
            businessUnit.selected,
            sortBy.selected,
            clientTypes,
            clientCRMTypes,
            clientCRMGroup,
            searchWord.searchWord,
            tab === "DETAILS",
            deletedStatus,
            role,
            isEntity,
            start,
            limit
          )
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const exportPeriodFinancialSheet = year => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      // year,
      collaborator,
      client,
      clientGroup,
      squads,
      cluster,
      businessUnit,
      sortBy,
      searchWord
    } = getState().financialSheet.periodFilter;
    // const {
    //   filter: { clientTypes, clientCRMTypes }
    // } = getState().financialSheet.periodTree;
    const {
      filter: { budgetState }
    } = getState().budget.dynamicTable;

    const {
      filter: {
        clientTypes,
        clientCRMTypes,
        clientCRMGroup,
        collaboratorRole,
        isEntity
      }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus, offshoreStatus, facturableStatus }
    } = getState().clients.filter;

    dispatch(
      actions.exportPeriodFinancialSheetTree(
        api.exportPeriodFinancialSheet(
          currentOrganization.id,
          client.selected,
          clientGroup.selected,
          collaborator.selected,
          year,
          squads.selected,
          cluster.selected,
          businessUnit.selected,
          sortBy.selected,
          searchWord.searchWord,
          true,
          clientTypes,
          budgetState.join(","),
          clientCRMTypes,
          clientCRMGroup,
          collaboratorRole,
          deletedStatus,
          offshoreStatus,
          facturableStatus,
          isEntity
        )
      )
    );
    // .then(res => {
    //   return res.data.data;
    // })
  };
};

export const importFinancialSheet = () => {
  return (dispatch, getState) => {
    const {
      importAttachment,
      importedYear
    } = getState().financialSheet.importFinancialSheet;
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.importFinancialSheet(
        api.importFinancialSheet({
          importAttachment,
          data: currentOrganization.id,
          importedYear
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/financial-sheet.js